<template>
 <div class="nav-wrapper">
  <div class="experience-container">
    <div class="form-section">
      <div class="business-form">
        <BackButton @back="$emit('back')" />
        <h1 class="main-title" >{{ $t('businessCategory.title') }}</h1>
        <p class="subtitle" :style="{marginBottom: '12px'}">{{ $t('businessCategory.subtitle') }}</p>

        <div class="form-group">
          <label>{{ $t('businessCategory.label') }}</label>
          <select v-model="businessCategory" class="form-input custom-select" :class="{ 'error': errors.businessCategory }">
            <option value="" disabled selected>{{ $t('businessCategory.placeholder') }}</option>
            <option value="restaurant">{{ $t('businessCategory.options.restaurant') }}</option>
            <option value="retail">{{ $t('businessCategory.options.retail') }}</option>
            <option value="consulting">{{ $t('businessCategory.options.consulting') }}</option>
            <option value="technology">{{ $t('businessCategory.options.technology') }}</option>
            <option value="construction">{{ $t('businessCategory.options.construction') }}</option>
            <option value="healthcare">{{ $t('businessCategory.options.healthcare') }}</option>
            <option value="real_estate">{{ $t('businessCategory.options.real_estate') }}</option>
            <option value="transportation">{{ $t('businessCategory.options.transportation') }}</option>
            <option value="manufacturing">{{ $t('businessCategory.options.manufacturing') }}</option>
            <option value="education">{{ $t('businessCategory.options.education') }}</option>
            <option value="personal_services">{{ $t('businessCategory.options.personal_services') }}</option>
            <option value="professional_services">{{ $t('businessCategory.options.professional_services') }}</option>
            <option value="entertainment">{{ $t('businessCategory.options.entertainment') }}</option>
            <option value="agriculture">{{ $t('businessCategory.options.agriculture') }}</option>
            <option value="other">{{ $t('businessCategory.options.other') }}</option>
          </select>
          <span class="error-message" v-if="errors.businessCategory">{{ $t(errors.businessCategory) }}</span>
        </div>

        <button class="next-button" @click="handleNext">{{ $t('businessCategory.next') }}</button>
        <button class="skip-button" @click="$emit('skip')">{{ $t('businessCategory.skip') }}</button>
      </div>
    </div>
    <div class="image-section">
      <img src="@/assets/slider7.jpg" alt="Business Category Selection" class="main-image">
    </div>
  </div>
 </div>
</template>

<script>
import BackButton from './BackButton.vue'

export default {
  name: 'BusinessCategory',
  components: {
    BackButton
  },
  data() {
    return {
      businessCategory: '',
      errors: {
        businessCategory: ''
      },
    }
  },
  methods: {
    validateForm() {
      this.errors = {
        businessCategory: ''
      };
      
      let isValid = true;

      if (!this.businessCategory) {
        this.errors.businessCategory = 'businessCategory.errors.required';
        isValid = false;
      }

      return isValid;
    },
    handleNext() {
      if (this.validateForm()) {
        this.$emit('next', {
          businessCategory: this.businessCategory
        });
      }
    }
  }
}
</script>

<style scoped>
@import '@/styles/CustomerBusiness.css';
</style> 